import type { FC, PropsWithChildren, ReactNode } from 'react';

import styles from './EmailSignatureEditorPanelNewFieldsSection.module.scss';

const EmailSignatureEditorPanelNewFieldsSection = ({
  ref: forwardedRef,
  children,
}: { children?: ReactNode } & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <div ref={forwardedRef} className={styles['em-sig-editor-new-fields-section']}>
      {children}
    </div>
  );
};

EmailSignatureEditorPanelNewFieldsSection.displayName = 'EmailSignatureEditorPanelNewFieldSection';

const EmailSignatureEditorPanelNewFieldsSectionHelper: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className={styles['em-sig-new-fields-helper']}>
      <span className={styles['tip-badge']}>Tip</span>
      <span>{children}</span>
    </div>
  );
};

export default EmailSignatureEditorPanelNewFieldsSection;

export { EmailSignatureEditorPanelNewFieldsSectionHelper };
